import React from 'react';

export const Images = ({ className, src, alt, imgClassname }) => {
  return (
    <div className={className}>
      <img
        loading="lazy"
        className={`m-auto  ${imgClassname}`}
        src={src}
        alt={alt}
      />
    </div>
  );
};
